module.exports = __webpack_public_path__ + "static/combedv2-33ee1ac1b804010c9afc8949a3cd7db0.png";